import { render, staticRenderFns } from "./NoteEditor.vue?vue&type=template&id=3a0902d9&scoped=true"
import script from "./NoteEditor.vue?vue&type=script&lang=ts"
export * from "./NoteEditor.vue?vue&type=script&lang=ts"
import style0 from "./NoteEditor.vue?vue&type=style&index=0&id=3a0902d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0902d9",
  null
  
)

export default component.exports